import logo from './logo.svg';
import './App.css';
import React, { useState, useEffect } from "react";
import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import 'bootstrap/dist/css/bootstrap.min.css';
import './custom2.css';
import Card from "react-bootstrap/Card";

import axios from 'axios'
import Button from 'react-bootstrap/esm/Button';
import Table from './table/Datatable';
import { SmartBasket } from './SmartBasket';
import { API_BASE_PATH } from './Api';



export default function Clusters() {

  var userInfo = localStorage.getItem("userInfo");
  if (userInfo) {
    userInfo = JSON.parse(userInfo);
  }

  const [clusterInfo, setClusterInfo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [smartBasket,setSmartBasket]=useState(null);
  

  const getClusterInfo = async () => new Promise((res, rej) => {
    axios.get(API_BASE_PATH+`/objects/clusters?lob=${userInfo.accountId}`)
      .then(response => {
        const data = response.data;
        res(data)
      })
      .catch(error => {
        console.log(error);
      })
  });

  const getPurchaseBasket = async (outletCode) => new Promise((res, rej) => {
    console.log(API_BASE_PATH+`/objects/spb/outletCode/${outletCode}?lob=${userInfo.accountId}`)
    axios.get(API_BASE_PATH+`/objects/spb/outletCode/${outletCode}?lob=${userInfo.accountId}&resolve=true`)
      .then(response => {
        const data = response.data;
        res(data)
      })
      .catch(error => {
        console.log(error);
      })
  });

  useEffect(() => {
    console.log("Called Useeffect of ClusterParent")
    getClusterInfo()
      .then(data => {
        setClusterInfo(data)
      }
      );
  }, [])

  const clickhandler =async (name,info) => {
    setLoading(true)
    setSmartBasket([]);
    console.log("view PB for", JSON.stringify(info))
    setSmartBasket((await getPurchaseBasket(info.outletCode)).sort(function(a, b){return a.relevance - b.relevance}).reverse())
    setLoading(false);
  };
  return (
    <div className="container mainPanel" >
      <div className="row">
        <div className="col-md-8 leftPaner" >
          <div className="row justify-content-center" style={{ margin: "auto", padding: "1px" }}>
            {
              clusterInfo && clusterInfo.map((item) => (
                <Card style={{ width: '18rem', margin: "10px" }}>
                  {/* <Card.Img variant="top" src="holder.js/100px180" /> */}
                  <Card.Body>
                    <Card.Title>Cluster {item.id}</Card.Title>
                    <Card.Text>
                      Capacity {item.rangekey}
                      <br></br>
                      Sample Count {item.payload.sampleCount}
                    </Card.Text>
                    {/* <Button variant="primary">View All</Button> */}
                  </Card.Body>
                </Card>
              ))
            }
          </div>
          <br></br>
          <div className="row">
            <div className="col-md-1"></div>
            <div className="col-md-10">
              <Table click={clickhandler} />
            </div>
            <div className="col-md-1"></div>
          </div>
          <br></br>
          
        </div>
        <div className="col-md-4 rightPanel">
          <div className="row">
            {/* <div className="col-md-5">
              <Card style={{ width: '18rem', margin: "10px" }}>
                <Card.Img variant="top" src="holder.js/100px180" /> 
                <Card.Body>
                  <Card.Title>Total Outlets</Card.Title>
                  <Card.Text>
                    </Card.Text>
                </Card.Body>
              </Card>
            </div>
            <div className="col-md-5">
              <Card style={{ width: '18rem', margin: "10px" }}>
                <Card.Img variant="top" src="holder.js/100px180" /> 
                <Card.Body>
                  <Card.Title>Total Users</Card.Title>
                  <Card.Text>
                    </Card.Text>
                </Card.Body>
              </Card>
            </div> */}
          </div>
        
          <div className="row">
            <div className="col-md-12">

            {
               loading && <h2 className="centerIt">Loading......</h2>

            }
              {
                smartBasket && smartBasket.length>0 && 
                <Card style={{ width: '31rem', margin: "10px" }}>
                  <Card.Body>
                    <Card.Title style={{background:"grey",color:"white",padding:"10px"}}>Outlet Summary</Card.Title>
                    <Card.Text>
                      OutletCode {smartBasket[0].outletCode}
                      <br></br>
                      LoginId {smartBasket[0].loginId}
                    </Card.Text>
                  </Card.Body>
                </Card>
              }
              {
              

               smartBasket && smartBasket.length>0 && <SmartBasket basket={smartBasket}/>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

